module.exports = __webpack_public_path__ + "img/home.a20e57d2.png";